// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type InfoCircle40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle40Filled: FC<InfoCircle40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path
                d="M20 35c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Zm1.049-20.249a1.44 1.44 0 0 1-1.05.416c-.416 0-.766-.139-1.048-.416a1.384 1.384 0 0 1-.423-1.029c0-.425.141-.781.423-1.069a1.412 1.412 0 0 1 1.05-.43c.416 0 .766.143 1.048.43.282.288.423.644.423 1.07 0 .409-.141.752-.423 1.028Zm.423 13.582h-2.777v-10h2.777v10Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default InfoCircle40Filled;
